import type { ScreenDiagnostic } from '@/api/screens';

/** Findings at this JSON pointer or inside it. */
export function under(diagnostics: ScreenDiagnostic[], path: string): ScreenDiagnostic[] {
  return diagnostics.filter((d) => d.path === path || d.path.startsWith(`${path}/`));
}

/** True when the gate refuses something at this pointer or inside it. */
export function errorAt(diagnostics: ScreenDiagnostic[], path: string): boolean {
  return under(diagnostics, path).some((d) => d.severity === 'ERROR');
}
